import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { signInTermsText } from '../../constants';

function TermsContainer({
  termsContainer,
  policyLink,
  termsText,
  fromSignup,
  helpingText,
}) {
  return (
    <div className={termsContainer}>
      <Typography variant="caption" className={termsText}>
        {!helpingText ? signInTermsText : helpingText}
        <Link
          href="/privacypolicy"
          target="_blank"
          color="inherit"
          className={policyLink}
        >
          Privacy Policy
        </Link>
        and
        <Link
          href="/termsofservice"
          target="_blank"
          color="inherit"
          className={policyLink}
        >
          Terms of Service.
        </Link>
      </Typography>
    </div>
  );
}

export default TermsContainer;
